import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IdleTimerService {
  timeout = parseInt('1' || '0');
  eventHandler: any;
  timeoutTracker: any;
  interval: any;

  onTimeout$: Subject<any> = new Subject<any>();
  refreshToken$: Subject<any> = new Subject<any>();

  constructor() {
    this.eventHandler = this.updateExpiredTime.bind(this);
    this.startInterval();
  }

  startInterval() {
    this.updateExpiredTime();

    this.interval = setInterval(() => {
      const expirationDate = parseInt(
        localStorage.getItem('_expiration_date') || '0',
        10
      );

      const refreshTokenDate = new Date(
        parseInt(localStorage.getItem('_expiration_date') || '0', 10) -
          0.3 * 60000
      ).getTime();

      if (Date.now() >= refreshTokenDate && Date.now() < expirationDate) {
        this.refreshToken$.next({ timeout: true });
        this.cleanUp();
      } else {
        if (expirationDate < Date.now() && localStorage.getItem('id_token')) {
          this.onTimeout$.next({ timeout: true });
          this.cleanUp();
        }
      }
    }, 1000);
  }

  updateExpiredTime() {
    if (this.timeoutTracker) {
      clearTimeout(this.timeoutTracker);
    }
  }

  tracker() {
    window.addEventListener('mousemove', this.eventHandler);
    window.addEventListener('scroll', this.eventHandler);
    window.addEventListener('keydown', this.eventHandler);
  }

  cleanUp() {
    clearInterval(this.interval);
  }
}
